module.exports = __webpack_public_path__ + "img/aheadworks.d64fa880.webp";